define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Provincial_1",
        THEMESETS_IDS: ["Provincial_1"],
        TOP_PANEL: {
            PRINT_OPTIONS: {"landscape": true, "scale": 0.5},
            DEFAULTS: {
                GRAPH_TYPE: "line",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 25, "top": 15, "right": 0, "bottom": 10},
                X_DATA_NAMES: [
                    "1999-2000", "2000-2001", "2001-2002", "2002-2003", "2003-2004", "2004-2005", "2005-2006", "2006-2007", "2007-2008",
                    "2008-2009", "2009-2010", "2010-2011", "2011-2012", "2012-2013", "2013-2014", "2014-2015", "2015-2016", "2016-2017",
                    "2017-2018", "2018-2019", "2019-2020", "2020-2021", "2021-2022", "2022-2023", "2023-2024"],
                // X_AXIS_LABEL: {"text": "Années scolaires", "position": "inner-right"},
                Y_AXIS_LABEL: "%",
                Y_AXIS_PADDING: 0,
                Y_GRID: true,
                DATA_COLORS: {
                    "Sexe masculin": "#095797",
                    "Sexe féminin": "#68CEBA",
                    "Sexes réunis": "#D0DC03"
                },
                DATA_CLASSES: {"Sexes réunis": "BbGraphs_dashed_line"},
                TOOLTIP_TITLE_FN: function(x, graph) { return "Année scolaire " + graph.categories()[x]; },
                ////TOOLTIP_VALUE_FN: function(y, graph) { return y + "%"; },
            },
            SLIDES: [
                {
                    TITLE: "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, en fonction du sexe, de 1999-2000 à 2024-2025 (données officielles)",
                    SUBTILE: null,
                    GRAPHS: [
                        {
                            TITLE: "Ensemble du Québec (tous les réseaux d'enseignement)",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 35,
                            X_AXIS_TICK_ROTATE: -90,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["0"],
                                    FEATURES_DATA_IDS: ["Sexe masculin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_M_1999_2000", "c_TX_M_2000_2001", "c_TX_M_2001_2002", "c_TX_M_2002_2003", "c_TX_M_2003_2004", "c_TX_M_2004_2005",
                                        "c_TX_M_2005_2006", "c_TX_M_2006_2007", "c_TX_M_2007_2008", "c_TX_M_2008_2009", "c_TX_M_2009_2010", "c_TX_M_2010_2011",
                                        "c_TX_M_2011_2012", "c_TX_M_2012_2013", "c_TX_M_2013_2014", "c_TX_M_2014_2015", "c_TX_M_2015_2016", "c_TX_M_2016_2017",
                                        "c_TX_M_2017_2018", "c_TX_M_2018_2019", "c_TX_M_2019_2020", "c_TX_M_2020_2021","c_TX_M_2021_2022","c_TX_M_2022_2023",
                                        "c_TX_M_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["0"],
                                    FEATURES_DATA_IDS: ["Sexe féminin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_F_1999_2000", "c_TX_F_2000_2001", "c_TX_F_2001_2002", "c_TX_F_2002_2003", "c_TX_F_2003_2004", "c_TX_F_2004_2005",
                                        "c_TX_F_2005_2006", "c_TX_F_2006_2007", "c_TX_F_2007_2008", "c_TX_F_2008_2009", "c_TX_F_2009_2010", "c_TX_F_2010_2011",
                                        "c_TX_F_2011_2012", "c_TX_F_2012_2013", "c_TX_F_2013_2014", "c_TX_F_2014_2015", "c_TX_F_2015_2016", "c_TX_F_2016_2017",
                                        "c_TX_F_2017_2018", "c_TX_F_2018_2019", "c_TX_F_2019_2020", "c_TX_F_2020_2021", "c_TX_F_2021_2022", "c_TX_F_2022_2023",
                                        "c_TX_F_2023_2024"
                                ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["0"],
                                    FEATURES_DATA_IDS: ["Sexes réunis"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_T_1999_2000", "c_TX_T_2000_2001", "c_TX_T_2001_2002", "c_TX_T_2002_2003", "c_TX_T_2003_2004", "c_TX_T_2004_2005",
                                        "c_TX_T_2005_2006", "c_TX_T_2006_2007", "c_TX_T_2007_2008", "c_TX_T_2008_2009", "c_TX_T_2009_2010", "c_TX_T_2010_2011",
                                        "c_TX_T_2011_2012", "c_TX_T_2012_2013", "c_TX_T_2013_2014", "c_TX_T_2014_2015", "c_TX_T_2015_2016", "c_TX_T_2016_2017",
                                        "c_TX_T_2017_2018", "c_TX_T_2018_2019", "c_TX_T_2019_2020", "c_TX_T_2020_2021", "c_TX_T_2021_2022", "c_TX_T_2022_2023",
                                        "c_TX_T_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        },
                        {
                            TITLE: "Réseau d'enseignement public",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 35,
                            X_AXIS_TICK_ROTATE: -90,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["1"],
                                    FEATURES_DATA_IDS: ["Sexe masculin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_M_1999_2000", "c_TX_M_2000_2001", "c_TX_M_2001_2002", "c_TX_M_2002_2003", "c_TX_M_2003_2004", "c_TX_M_2004_2005",
                                        "c_TX_M_2005_2006", "c_TX_M_2006_2007", "c_TX_M_2007_2008", "c_TX_M_2008_2009", "c_TX_M_2009_2010", "c_TX_M_2010_2011",
                                        "c_TX_M_2011_2012", "c_TX_M_2012_2013", "c_TX_M_2013_2014", "c_TX_M_2014_2015", "c_TX_M_2015_2016", "c_TX_M_2016_2017",
                                        "c_TX_M_2017_2018", "c_TX_M_2018_2019", "c_TX_M_2019_2020", "c_TX_M_2020_2021", "c_TX_M_2021_2022", "c_TX_M_2022_2023",
                                        "c_TX_M_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["1"],
                                    FEATURES_DATA_IDS: ["Sexe féminin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_F_1999_2000", "c_TX_F_2000_2001", "c_TX_F_2001_2002", "c_TX_F_2002_2003", "c_TX_F_2003_2004", "c_TX_F_2004_2005",
                                        "c_TX_F_2005_2006", "c_TX_F_2006_2007", "c_TX_F_2007_2008", "c_TX_F_2008_2009", "c_TX_F_2009_2010", "c_TX_F_2010_2011",
                                        "c_TX_F_2011_2012", "c_TX_F_2012_2013", "c_TX_F_2013_2014", "c_TX_F_2014_2015", "c_TX_F_2015_2016", "c_TX_F_2016_2017",
                                        "c_TX_F_2017_2018", "c_TX_F_2018_2019", "c_TX_F_2019_2020", "c_TX_F_2020_2021", "c_TX_F_2021_2022", "c_TX_F_2022_2023",
                                        "c_TX_F_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["1"],
                                    FEATURES_DATA_IDS: ["Sexes réunis"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_T_1999_2000", "c_TX_T_2000_2001", "c_TX_T_2001_2002", "c_TX_T_2002_2003", "c_TX_T_2003_2004", "c_TX_T_2004_2005",
                                        "c_TX_T_2005_2006", "c_TX_T_2006_2007", "c_TX_T_2007_2008", "c_TX_T_2008_2009", "c_TX_T_2009_2010", "c_TX_T_2010_2011",
                                        "c_TX_T_2011_2012", "c_TX_T_2012_2013", "c_TX_T_2013_2014", "c_TX_T_2014_2015", "c_TX_T_2015_2016", "c_TX_T_2016_2017",
                                        "c_TX_T_2017_2018", "c_TX_T_2018_2019", "c_TX_T_2019_2020", "c_TX_T_2020_2021", "c_TX_T_2021_2022", "c_TX_T_2022_2023",
                                        "c_TX_T_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        },
                        {
                            TITLE: "Réseau d'enseignement privé",
                            Y_AXIS_MIN_VALUE: 0,
                            Y_AXIS_MAX_VALUE: 35,
                            X_AXIS_TICK_ROTATE: -90,
                            HEIGHT_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 100;
                                else return 315;
                            },
                            WIDTH_FN: function() { 
                                if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /2 - 75;
                                else return $("#BbGraphs_topPanel_container").width() - 20;
                            },
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["2"],
                                    FEATURES_DATA_IDS: ["Sexe masculin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_M_1999_2000", "c_TX_M_2000_2001", "c_TX_M_2001_2002", "c_TX_M_2002_2003", "c_TX_M_2003_2004", "c_TX_M_2004_2005",
                                        "c_TX_M_2005_2006", "c_TX_M_2006_2007", "c_TX_M_2007_2008", "c_TX_M_2008_2009", "c_TX_M_2009_2010", "c_TX_M_2010_2011",
                                        "c_TX_M_2011_2012", "c_TX_M_2012_2013", "c_TX_M_2013_2014", "c_TX_M_2014_2015", "c_TX_M_2015_2016", "c_TX_M_2016_2017",
                                        "c_TX_M_2017_2018", "c_TX_M_2018_2019", "c_TX_M_2019_2020", "c_TX_M_2020_2021","c_TX_M_2021_2022","c_TX_M_2022_2023",
                                        "c_TX_M_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["2"],
                                    FEATURES_DATA_IDS: ["Sexe féminin"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_F_1999_2000", "c_TX_F_2000_2001", "c_TX_F_2001_2002", "c_TX_F_2002_2003", "c_TX_F_2003_2004", "c_TX_F_2004_2005",
                                        "c_TX_F_2005_2006", "c_TX_F_2006_2007", "c_TX_F_2007_2008", "c_TX_F_2008_2009", "c_TX_F_2009_2010", "c_TX_F_2010_2011",
                                        "c_TX_F_2011_2012", "c_TX_F_2012_2013", "c_TX_F_2013_2014", "c_TX_F_2014_2015", "c_TX_F_2015_2016", "c_TX_F_2016_2017",
                                        "c_TX_F_2017_2018", "c_TX_F_2018_2019", "c_TX_F_2019_2020", "c_TX_F_2020_2021", "c_TX_F_2021_2022","c_TX_F_2022_2023",
                                        "c_TX_F_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                },
                                {
                                    LAYER_ID: "ThematiqueProv_RESEAUX",
                                    FEATURES_IDS: ["2"],
                                    FEATURES_DATA_IDS: ["Sexes réunis"],
                                    DATATABLE_ID: "t_Provincial_res",
                                    DATACOLUMNS_IDS: [
                                        "c_TX_T_1999_2000", "c_TX_T_2000_2001", "c_TX_T_2001_2002", "c_TX_T_2002_2003", "c_TX_T_2003_2004", "c_TX_T_2004_2005",
                                        "c_TX_T_2005_2006", "c_TX_T_2006_2007", "c_TX_T_2007_2008", "c_TX_T_2008_2009", "c_TX_T_2009_2010", "c_TX_T_2010_2011",
                                        "c_TX_T_2011_2012", "c_TX_T_2012_2013", "c_TX_T_2013_2014", "c_TX_T_2014_2015", "c_TX_T_2015_2016", "c_TX_T_2016_2017",
                                        "c_TX_T_2017_2018", "c_TX_T_2018_2019", "c_TX_T_2019_2020", "c_TX_T_2020_2021", "c_TX_T_2021_2022","c_TX_T_2022_2023",
                                        "c_TX_T_2023_2024"
                                    ],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        },
                    ]
                }
            ]
        }
    };
});
